const INTEGRATIONS_ACTIONS = {
  CARD_CLICK: 'Integrations > Explore > Click on the card',
  GET_BTN_CLICK: 'Integrations > Get it now',
  ADD_BTN_CLICK: 'Integrations > Add',
  USE_BTN_CLICK: 'Integrations > Use now',
  MENU_EXPLORE: 'Integrations > Explore',
  MENU_POWER_POINT: 'Integrations > PowerPoint',
  MENU_TEAMS: 'Integrations > Microsoft Teams',
  MENU_ZOOM: 'Integrations > Zoom',
  MENU_GOOGLE_SLIDES: 'Integrations > Google Slides',
  MENU_CHAT_GPT: 'Integrations > ChatGPT',
  TIP_CLICK: 'Integrations > Click on the text link',
}

export {
  INTEGRATIONS_ACTIONS,
}
